module.exports = __webpack_public_path__ + "img/404-background.f38ddaf9.png";